import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import ChangeTransactionIdentifier from "./change_transaction_identifier.js";
import Loading from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const Transactions = (props) => {
  const [search, setSearch] = useState("");
  const [searchName, setSearchName] = useState("");
  const [searchTitle, setSearchTitle] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [transactionsClear, setTransactionsClear] = useState([]);
  const [showChangeTransactionIdentifier, setShowChangeTransactionIdentifier] =
    useState(false);
  const [sortTr, setSortTr] = useState("");
  const [filterTr, setFilterTr] = useState("");
  const [transactionValue, setTransactionValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [trToDel, setTrToDel] = useState([]);
  const [expandMobileFilters, setExpandMobileFilters] = useState(false);

  const handleExpandMobileChange = () => {
    setExpandMobileFilters(!expandMobileFilters);
  };

  const fetchTransactionsAss = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTransactionsAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTransactions(
          data.sort(function (a, b) {
            return new Date(b.assign_date) - new Date(a.assign_date);
          })
        );
        setTransactionsClear(
          data.sort(function (a, b) {
            return new Date(b.assign_date) - new Date(a.assign_date);
          })
        );
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchTransactionsNAss = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTransactionsNotAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTransactions(
          data.sort(function (a, b) {
            return new Date(b.assign_date) - new Date(a.assign_date);
          })
        );
        setTransactionsClear(
          data.sort(function (a, b) {
            return new Date(b.assign_date) - new Date(a.assign_date);
          })
        );
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    props.type === "assigned"
      ? fetchTransactionsAss()
      : fetchTransactionsNAss();
  };

  useEffect(() => {
    getData();
  }, []);

  const handleShowChangeTransactionIdentifier = (e) => {
    setShowChangeTransactionIdentifier(!showChangeTransactionIdentifier);
    if (!showChangeTransactionIdentifier === false) {
      getData();
    }
  };

  const clearSearch = (e) => {
    setSearchName("");
    setSearch("");
    setSearchTitle("");
    setSearchDate("");
    setSortTr("desc_import");
    setFilterTr("wszystkie");
    setTransactions(
      transactionsClear.sort(function (a, b) {
        return new Date(b.assign_date) - new Date(a.assign_date);
      })
    );
  };

  const handleSortChange = (e) => {
    setSortTr(e.target.value);
    if (e.target.value === "desc_import") {
      setTransactions(
        transactions.sort(function (a, b) {
          return new Date(b.assign_date) - new Date(a.assign_date);
        })
      );
    } else if (e.target.value === "asc_import") {
      setTransactions(
        transactions.sort(function (a, b) {
          return new Date(a.assign_date) - new Date(b.assign_date);
        })
      );
    } else if (e.target.value === "desc_tr") {
      setTransactions(
        transactions.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date);
        })
      );
    } else if (e.target.value === "asc_tr") {
      setTransactions(
        transactions.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date);
        })
      );
    }
  };

  const handleRowClick = (e) => {
    e.preventDefault();
    var value = e.currentTarget.attributes.value.value;
    setTransactionValue(value);
    handleShowChangeTransactionIdentifier();
  };

  const handleSearchDateChange = (e) => {
    setSearchName("");
    setSearch("");
    setSearchTitle("");
    setSearchDate(e.target.value);
    if (e.target.value === "") {
      setTransactions(transactionsClear);
    } else {
      setTransactions(
        transactionsClear.filter(
          (el) =>
            new Date(el.assign_date).getFullYear() +
              "-" +
              new Date(el.assign_date).getMonth() +
              "-" +
              new Date(el.assign_date).getDate() ===
            new Date(e.target.value).getFullYear() +
              "-" +
              new Date(e.target.value).getMonth() +
              "-" +
              new Date(e.target.value).getDate()
        )
      );
    }
  };

  const handleSearchTitleChange = (e) => {
    setSearchName("");
    setSearch("");
    setSearchDate("");
    setSearchTitle(e.target.value);
    if (e.target.value === "") {
      setTransactions(transactionsClear);
    } else {
      setTransactions(
        transactionsClear.filter((el) =>
          el.title
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase())
        )
      );
    }
  };

  const handleSearchChange = (e) => {
    setSearchName("");
    setSearchTitle("");
    setSearchDate("");
    setSearch(e.target.value);
    if (e.target.value === "") {
      setTransactions(transactionsClear);
    } else {
      setTransactions(
        transactionsClear.filter((el) =>
          el.payId
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase())
        )
      );
    }
  };

  const handleSearchNameChange = (e) => {
    setSearch("");
    setSearchTitle("");
    setSearchDate("");
    setSearchName(e.target.value);
    if (e.target.value === "") {
      setTransactions(transactionsClear);
    } else {
      var arr = transactionsClear.filter((el) =>
        el.client
          .toString()
          .toLowerCase()
          .includes(e.target.value.toString().toLowerCase())
      );
      setTransactions(arr.length > 0 ? arr : []);
    }
  };

  const handleFilterChange = (e) => {
    setFilterTr(e.target.value);
    if (e.target.value === "oznaczone") {
      setTransactions(transactionsClear.filter((el) => el.checked === 1));
    } else if (e.target.value === "wszystkie") {
      setTransactions(transactionsClear);
    } else {
      setTransactions(
        transactionsClear.filter(
          (el) =>
            el.reason.toString().toLowerCase() ===
            e.target.value.toString().toLowerCase()
        )
      );
    }
  };

  const deleteTransactionAccMany = async (e) => {
    MySwal.fire({
      title: "Czy na pewno chcesz usunąć zaznaczone transakcję?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        props.type === "assigned"
          ? deleteTransactionAssignedMany()
          : deleteTransactionMany();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deleteTransactionAcc = async (e) => {
    MySwal.fire({
      title: "Czy na pewno chcesz usunąć transakcję?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        props.type === "assigned"
          ? deleteTransactionAssigned(e.target.value)
          : deleteTransaction(e.target.value);
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deleteTransactionAssignedMany = async (id) => {
    transactionsClear.map(async (el3) => {
      if (checkTransactionsToDelete(el3.tr_id)) {
        var body = {
          date: el3.date,
          client: el3.client,
          title: el3.title,
          bank_acc: el3.bank_acc,
          tr_id: el3.tr_id,
          bank: el3.bank,
          bill: el3.bill,
          assign_date: el3.assign_date,
          checked: el3.checked,
          reason: "",
          note: el3.note,
          payId: "",
        };

        await fetch(
          "https://apidevkppp.ftpeople.pl/insertTransactionsNotAssigned",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          }
        )
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        var body = {
          tr_id: el3.tr_id,
        };

        await fetch(
          "https://apidevkppp.ftpeople.pl/deleteTransactionAssigned",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          }
        )
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
      }
    });

    var body = {};
    await fetch("https://apidevkppp.ftpeople.pl/getTransactionsAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Wycofano",
          text: "transakcję",
        }).then((result) => {
          getData();
        });
        return;

        checkPayments(data);
      })
      .catch((error) => {});
  };

  const checkTransactionsToDelete = (id) => {
    var arr = trToDel.filter((el) => el === id);
    if (arr.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const deleteTransactionAssigned = async (id) => {
    var toEditData = transactionsClear.filter((el) => +el.tr_id === +id)[0];

    var body = {
      date: toEditData.date,
      client: toEditData.client,
      title: toEditData.title,
      bank_acc: toEditData.bank_acc,
      tr_id: toEditData.tr_id,
      bank: toEditData.bank,
      bill: toEditData.bill,
      assign_date: toEditData.assign_date,
      checked: toEditData.checked,
      reason: "",
      note: toEditData.note,
      payId: "",
    };

    await fetch(
      "https://apidevkppp.ftpeople.pl/insertTransactionsNotAssigned",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      }
    )
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    var body = {
      tr_id: toEditData.tr_id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteTransactionAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Wycofano",
      text: "transakcję",
    }).then((result) => {
      getData();
    });

    return;

    await fetch("https://apidevkppp.ftpeople.pl/getTransactionsAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        checkPayments(data);
      })
      .catch((error) => {});
  };

  const deleteTransactionMany = async () => {
    transactionsClear.map(async (el3) => {
      if (checkTransactionsToDelete(el3.tr_id)) {
        var body = {
          tr_id: el3.tr_id,
        };

        await fetch(
          "https://apidevkppp.ftpeople.pl/deleteTransactionNotAssigned",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          }
        )
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
      }
    });

    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text: "transakcję",
    }).then((result) => {
      getData();
    });
  };

  const deleteTransaction = async (id) => {
    var body = {
      tr_id: id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteTransactionNotAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text: "transakcję",
    }).then((result) => {
      getData();
    });
  };

  const checkExpectedTransactionsCount = (
    dateOfStartPayment,
    installmentCount
  ) => {
    var now = new Date();
    var startDate = new Date(dateOfStartPayment);
    var months = (now.getFullYear() - startDate.getFullYear()) * 12;
    months -= startDate.getMonth();
    months += now.getMonth();
    return months <= 0
      ? 0
      : months > installmentCount
      ? installmentCount
      : months;
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const checkPayments = async (transactions) => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getPayments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data
          .filter((el) => !el.archive_date)
          .map(async (el) => {
            var transactionsForPayment = transactions.filter(
              (tr) => tr.payId === el.identifier
            );
            transactionsForPayment.sort(function (a, b) {
              return new Date(b.date) - new Date(a.date);
            });
            var pay_sum = 0;
            for (var i = 0; i < transactionsForPayment.length; i += 1) {
              pay_sum =
                parseFloat(
                  transactionsForPayment[i].bill.replaceAll(",", ".")
                ) + pay_sum;
            }

            var archive =
              parseInt(el.to_settlement) === parseInt(pay_sum) ? "TAK" : "NIE";
            var bankAcc = el.bank_acc;
            if (transactionsForPayment.length > 0) {
              if (!transactionsForPayment[0].title.includes("Wpłata w UP")) {
                bankAcc = transactionsForPayment[0].bank_acc;
              }
            }

            var body2 = {
              identifier: el.identifier,
              pay_sum: pay_sum,
              bank_acc: bankAcc,
              pay_count: transactionsForPayment.length,
              pay_expected_count: checkExpectedTransactionsCount(
                el.first_payment_date,
                el.installment
              ),
              last_pay_date:
                transactionsForPayment.length > 0
                  ? transactionsForPayment[0].date
                  : "",
              is_overdated:
                checkExpectedTransactionsCount(
                  el.first_payment_date,
                  el.installment
                ) > transactionsForPayment.length
                  ? "TAK"
                  : "NIE",
              to_archive:
                parseInt(el.to_settlement.toString().replace(",", ".")) ===
                parseInt(pay_sum.toString().replace(",", "."))
                  ? "TAK"
                  : "NIE",
              delay_time:
                archive === "TAK"
                  ? 0
                  : getDelayTime(
                      el.first_payment_date,
                      transactionsForPayment.length,
                      checkExpectedTransactionsCount(
                        el.first_payment_date,
                        el.installment
                      )
                    ),
            };

            await fetch("https://apidevkppp.ftpeople.pl/editPaymentCheck", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body2),
            })
              .then((response) => response.json())
              .then((data) => {})
              .catch((error) => {});
          });
      })
      .catch((error) => {});
    MySwal.fire({
      icon: "success",
      title: "Wycofano",
      text: "transakcję",
    }).then((result) => {
      getData();
    });
  };

  const days = (date_1, date_2) => {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    return TotalDays;
  };

  const getDelayTime = (dateOfStartPayment, pay_sum, expected_pay_count) => {
    var startDate = new Date(dateOfStartPayment);
    var now = new Date();
    var lastPaymentDateForDelay = new Date(
      startDate.setMonth(startDate.getMonth() + pay_sum)
    );
    var delay_days = days(now, lastPaymentDateForDelay);
    return delay_days < 0 ? 0 : delay_days;
  };

  const checkTr = async (e) => {
    setLoading(true);

    var checked =
      +transactionsClear.filter((el) => +el.tr_id === +e.target.value)[0]
        .checked === 1
        ? 0
        : 1;

    var body = {
      tr_id: e.target.value,
      checked: checked,
      type: props.type,
    };

    await fetch("https://apidevkppp.ftpeople.pl/editTransactionChecked", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {})
      .catch((error) => {});

    if (checked === 1) {
      MySwal.fire({
        icon: "success",
        title: "Oznaczono",
        text: "transakcję",
      }).then((result) => {
        getData();
      });
    } else {
      MySwal.fire({
        icon: "success",
        title: "Odznaczono",
        text: "transakcję",
      }).then((result) => {
        getData();
      });
    }
  };

  const checkTrToDel = (e) => {
    var id = e.target.value;

    var arr = trToDel.filter((el) => el === id);
    var newTrToDel = trToDel;
    if (arr.length > 0) {
      newTrToDel = newTrToDel.filter((el) => el !== id);
    } else {
      newTrToDel.push(id);
    }

    setTrToDel(newTrToDel);
  };

  const transactionsData = (
    <>
      <table className="clients_table">
        <tr key={0}>
          <th>Oznacz</th>
          <th>Data transakcji</th>
          <th>Imię i nazwisko</th>
          <th>Tytuł przelewu</th>
          <th>Numer konta</th>
          <th>Bank</th>
          <th>ID</th>
          <th>Kwota</th>
          <th>ID rozliczenia</th>
          <th>Powód</th>
          <th>Data importu</th>
          {props.user.role === "admin" ? <th>Akcja</th> : ""}
        </tr>
        {transactions.map((el) => (
          <>
            <tr id={el.checked === 1 ? "greenRowTr" : ""}>
              <td>
                <input
                  id="checkCal3"
                  type="checkbox"
                  checked={+el.checked === 0 ? false : true}
                  value={el.tr_id}
                  onChange={checkTr}
                />
              </td>
              <td value={el.tr_id} onClick={handleRowClick}>
                {el.date}
              </td>
              <td value={el.tr_id} onClick={handleRowClick}>
                {el.client}
              </td>
              <td value={el.tr_id} onClick={handleRowClick}>
                {el.title}
              </td>
              <td value={el.tr_id} onClick={handleRowClick}>
                {el.bank_acc}
              </td>
              <td value={el.tr_id} onClick={handleRowClick}>
                {el.bank}
              </td>
              <td value={el.tr_id} onClick={handleRowClick}>
                {el.tr_id}
              </td>
              <td value={el.tr_id} onClick={handleRowClick}>
                {el.bill}
              </td>
              <td value={el.tr_id} onClick={handleRowClick}>
                {el.payId}
              </td>
              <td value={el.tr_id} onClick={handleRowClick}>
                {el.reason}
              </td>
              <td value={el.tr_id} onClick={handleRowClick}>
                {new Date(el.assign_date).getFullYear() +
                  "-" +
                  (new Date(el.assign_date).getMonth() + 1 < 10
                    ? "0" + (new Date(el.assign_date).getMonth() + 1)
                    : new Date(el.assign_date).getMonth() + 1) +
                  "-" +
                  (new Date(el.assign_date).getDate() < 10
                    ? "0" + new Date(el.assign_date).getDate()
                    : new Date(el.assign_date).getDate())}
              </td>
              {props.user.role === "admin" ? (
                <td>
                  <input
                    id="checkCal3"
                    type="checkbox"
                    value={el.tr_id}
                    onChange={checkTrToDel}
                  />
                  <button
                    id="deleteButtonTr"
                    className="paymentMenuButton"
                    value={el.tr_id}
                    onClick={deleteTransactionAcc}
                  >
                    Usuń
                  </button>
                </td>
              ) : (
                ""
              )}
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const transactionsDataMobile = (
    <>
      <table className="clients_table">
        <tr key={0}>
          <th style={{ fontSize: "3vw" }}>Data transakcji</th>
          <th style={{ fontSize: "3vw" }}>Tytuł przelewu</th>
        </tr>
        {transactions.map((el) => (
          <>
            <tr id={el.checked === 1 ? "greenRowTr" : ""}>
              <td value={el.tr_id} onClick={handleRowClick}>
                {el.date}
              </td>
              <td value={el.tr_id} onClick={handleRowClick}>
                {el.title}
              </td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const desktopFilters = (
    <>
      <div className="closeButtonBoxNotePopUp">
        <div className="searchBoxP">
          <label>Wyszukaj po imieniu i nazwisku</label>
          <input
            type="text"
            id="name"
            name="name"
            value={searchName}
            onChange={handleSearchNameChange}
          />
        </div>
        <div className="searchBoxP">
          <label>Wyszukaj po ID</label>
          <input
            type="text"
            id="name"
            name="name"
            value={search}
            onChange={handleSearchChange}
          />
        </div>
        <div className="searchBoxP">
          <label>Wyszukaj po tytule przelewu</label>
          <input
            type="text"
            id="name"
            name="name"
            value={searchTitle}
            onChange={handleSearchTitleChange}
          />
        </div>
        <div className="searchBoxP">
          <label>Wyszukaj po dacie importu</label>
          <input
            type="date"
            id="name"
            name="name"
            value={searchDate}
            onChange={handleSearchDateChange}
          />
        </div>
        <div className="searchBoxP">
          <label>Sortuj</label>
          <select
            type="date"
            id="name"
            name="name"
            value={sortTr}
            onChange={handleSortChange}
          >
            <option key={0} value="desc_import">
              data importu - od najmłodszych
            </option>
            <option key={1} value="asc_import">
              data importu - od najstarszych
            </option>
            <option key={2} value="desc_tr">
              data transakcji - od najmłodszych
            </option>
            <option key={3} value="asc_tr">
              data transakcji - od najstarszych
            </option>
          </select>
        </div>
        <div className="filterBoxP">
          <label>Filtrowanie</label>
          <select
            type="text"
            id="filterP"
            name="court"
            value={filterTr}
            onChange={handleFilterChange}
          >
            <option key={6} value="wszystkie">
              Wszystkie
            </option>
            <option key={7} value="oznaczone">
              Oznaczone
            </option>
            <option key={0} value="nazwa nadawcy">
              Nazwa nadawcy
            </option>
            <option key={1} value="identyfikator">
              Identyfikator
            </option>
            <option key={2} value="tytuł przelewu">
              Tytuł przelewu
            </option>
            <option key={3} value="numer konta bankowego">
              Numer konta bankowego
            </option>
            <option key={4} value="zmiana identyfikatora">
              Zmiana identyfikatora
            </option>
            <option key={5} value="przypisanie ręczne">
              Przypisanie ręczne
            </option>
          </select>
        </div>
      </div>
      <div id="closeButtonTR" className="closeButtonBoxNotePopUp">
        <button className="paymentMenuButton" onClick={clearSearch}>
          wyczyść filtry
        </button>
        {trToDel.length > 0 ? (
          <button
            className="paymentMenuButton"
            onClick={deleteTransactionAccMany}
          >
            usuń zaznaczone
          </button>
        ) : (
          ""
        )}
      </div>
    </>
  );

  const mobileFilters = (
    <>
      <div
        style={
          expandMobileFilters
            ? { display: "flex", width: "100%", padding: "3vh 0" }
            : { display: "flex", width: "100%", padding: "3vh 0" }
        }
      >
        <div style={{ width: "100%" }}>
          <button
            className="calendarUserButton"
            style={{ width: "100%", justifyContent: "center" }}
            onClick={handleExpandMobileChange}
          >
            {!expandMobileFilters ? "ROZWIŃ FILTRY" : "ZWIŃ FILTRY"}
          </button>
        </div>
      </div>
      {expandMobileFilters ? (
        <>
          <div className="closeButtonBoxNotePopUp" style={{ flexWrap: "wrap" }}>
            <div
              className="searchBoxP"
              style={{ width: "100%", marginBottom: "1vh" }}
            >
              <label>Wyszukaj po imieniu i nazwisku</label>
              <input
                type="text"
                id="name"
                name="name"
                value={searchName}
                onChange={handleSearchNameChange}
              />
            </div>
            <div
              className="searchBoxP"
              style={{ width: "100%", marginBottom: "1vh" }}
            >
              <label>Wyszukaj po ID</label>
              <input
                type="text"
                id="name"
                name="name"
                value={search}
                onChange={handleSearchChange}
              />
            </div>
            <div
              className="searchBoxP"
              style={{ width: "100%", marginBottom: "1vh" }}
            >
              <label>Wyszukaj po tytule przelewu</label>
              <input
                type="text"
                id="name"
                name="name"
                value={searchTitle}
                onChange={handleSearchTitleChange}
              />
            </div>
            <div
              className="searchBoxP"
              style={{ width: "100%", marginBottom: "1vh" }}
            >
              <label>Wyszukaj po dacie importu</label>
              <input
                type="date"
                id="name"
                name="name"
                value={searchDate}
                onChange={handleSearchDateChange}
              />
            </div>
            <div
              className="searchBoxP"
              style={{ width: "100%", marginBottom: "1vh" }}
            >
              <label>Sortuj</label>
              <select
                type="date"
                id="name"
                name="name"
                value={sortTr}
                onChange={handleSortChange}
              >
                <option key={0} value="desc_import">
                  data importu - od najmłodszych
                </option>
                <option key={1} value="asc_import">
                  data importu - od najstarszych
                </option>
                <option key={2} value="desc_tr">
                  data transakcji - od najmłodszych
                </option>
                <option key={3} value="asc_tr">
                  data transakcji - od najstarszych
                </option>
              </select>
            </div>
            <div
              className="filterBoxP"
              style={{ width: "100%", marginBottom: "1vh" }}
            >
              <label>Filtrowanie</label>
              <select
                type="text"
                id="filterP"
                name="court"
                value={filterTr}
                onChange={handleFilterChange}
              >
                <option key={6} value="wszystkie">
                  Wszystkie
                </option>
                <option key={7} value="oznaczone">
                  Oznaczone
                </option>
                <option key={0} value="nazwa nadawcy">
                  Nazwa nadawcy
                </option>
                <option key={1} value="identyfikator">
                  Identyfikator
                </option>
                <option key={2} value="tytuł przelewu">
                  Tytuł przelewu
                </option>
                <option key={3} value="numer konta bankowego">
                  Numer konta bankowego
                </option>
                <option key={4} value="zmiana identyfikatora">
                  Zmiana identyfikatora
                </option>
                <option key={5} value="przypisanie ręczne">
                  Przypisanie ręczne
                </option>
              </select>
            </div>
          </div>
          <div
            id="closeButtonTR"
            className="closeButtonBoxNotePopUp"
            style={{ width: "100%", marginTop: "2vh" }}
          >
            <button className="paymentMenuButton" onClick={clearSearch}>
              wyczyść filtry
            </button>
            {trToDel.length > 0 ? (
              <button
                className="paymentMenuButton"
                onClick={deleteTransactionAccMany}
              >
                usuń zaznaczone
              </button>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <>
      <div className="mainContainerTransactions">
        {loading ? (
          <Loading />
        ) : (
          <>
            <div className="closeButtonBoxNotePopUp">
              <div className="closeButtonBoxNotePopUp_col1">
                {props.type === "not_assigned"
                  ? "Lista transakcji - ilość rekordów " + transactions.length
                  : "Lista transakcji archiwalnych - ilość rekordów " +
                    transactions.length}
              </div>
            </div>
            {showChangeTransactionIdentifier ? (
              <ChangeTransactionIdentifier
                close={handleShowChangeTransactionIdentifier}
                paymentsData={props.paymentsData}
                paymentsSheetData={props.paymentsSheetData}
                transactionsSheetData={props.transactionsSheetData}
                transactionsData={transactions}
                transactionsAData={props.transactionsAData}
                transactionsASheetData={props.transactionsASheetData}
                id={transactionValue}
                type={props.type}
                refreshData={props.refreshData}
                paymentId={null}
              />
            ) : (
              ""
            )}
            <div className="desktopFilters">{desktopFilters}</div>
            <div className="mobileFilters">{mobileFilters}</div>
            <>
              <span className="noteModuleP">
                kliknij w rekord, aby zmienić ID
              </span>
              <div className="contentBoxPayments">
                <div className="desktopFilters">{transactionsData}</div>
                <div className="mobileFilters">{transactionsDataMobile}</div>
              </div>
            </>
          </>
        )}
      </div>
    </>
  );
};

export default Transactions;
